import { Component, OnInit, Input } from '@angular/core';
import { BlurInputErrorMatcher } from '../../../../../modules/material/material.errror';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { ApiurlsService } from '../../../../../services/api-urls/apiurls.service';
import { ApirequestService } from '../../../../../services/apirequest/apirequest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../../../../services/utilities/utilities.services';
import { forEach } from '@angular/router/src/utils/collection';



@Component({
  selector: 'hybse-admin-add-market',
  templateUrl: './add-market.component.html',
  styleUrls: ['./add-market.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class AddMarketComponent implements OnInit {

  constructor(private _fb: FormBuilder,
    private _urls: ApiurlsService,
    private _ar: ActivatedRoute,
    private _utils: UtilityService,
    private router: Router,
    private _api: ApirequestService) { }
  fadeInDown: any;
  createMarketForm: FormGroup;
  blurMatcher = new BlurInputErrorMatcher();
  @Input() actionType: any = 'add';
  marketId: any = 0;
  symbolList: any = [];
  companyList: any = [];
  sourceSymbol: string = '';
  targetSymbol: any = [];
  sourceSymbolId: any = '';
  targetSymbolId: any = '';
  idPairSource: string = '';
  primarySymbol: string = '';
  showLoader: boolean = false;
  responseMessage: string = '';
  targetPair: string;
  public selectedIbin: string;
  public selectedTargetSymbol: string;
  addTitle: string = 'ADD/EDIT MARKET';
  @Input() isDemo: boolean = false;


  createMarketFormInit() {
    this.createMarketForm = this._fb.group({
      'source_symbol': ['', [Validators.required]],
      'target_symbol': ['', [Validators.required]],
      'companies': ['', [Validators.required]],
      'initial_value': ['', [Validators.required]],
      'nemMosaic': ['', Validators.required],
      'nemNamespace': ['', Validators.required],
      'askSize': ['', (this.actionType != "edit") ? [Validators.required] : ''],
      'ibin': [null]
    });
  }


  createUpdateSubmit() {
    if (this.createMarketForm.valid) {
      this.showLoader = true;
      let formVal = this.createMarketForm.value;
      let idCompany = this._utils.filteredObj(this.companyList, 'idCompany', formVal.companies);
      let data: any = {
        idPairTarget: formVal.target_symbol,
        pairTarget: this.targetPair,
        pairSource: formVal.source_symbol,
        idCompany: formVal.companies,
        initialValue: formVal.initial_value,
        nemNamespace: formVal.nemNamespace,
        nemMosaic: formVal.nemMosaic,
        askSize: formVal.askSize,
        companyName: idCompany[0].companyName,
        isDemo: (this.isDemo) ? 1 : 0
      };
      let url = this._urls.createMarketUrl;

      if (this.actionType == 'edit') {
        url = this._urls.updateMarketUrl; data.idCompanyStock = this.marketId;
        data.idPairSource = this.idPairSource;
      }

      this._api.fetchApiData(url, data).subscribe(
        (data: any) => {
          let resSucc = data.data;
          this._utils.scrollToY(0, 400, 'easeInOutQuint');
          if (resSucc != '') {
            this.responseMessage = (this.actionType == 'add') ? 'Markets Created Successfully' : 'Markets Updated Successfully';
            setTimeout(() => {
              this.router.navigate([(this.isDemo) ? '/demo-company/markets/list' : '/markets/list']);
            }, 2000);
          }
        },
        error => {

        },
        () => {
          this.showLoader = false;
        }
      )
    }
  }

  getSymbolList() {
    let url: string;
    if (this.isDemo) url = this._urls.listDemoSymbolUrl;
    this._api.fetchApiData(url, {}).subscribe(
      (data: any) => {
        let resSucc = data.data;
        if (resSucc != '') {
          this.symbolList = resSucc;
          this.sourceSymbol = this._utils.getPropValFromObj(this.symbolList, 'idSymbol', 'symbol', this.sourceSymbolId);
          this.createMarketForm.controls['source_symbol'].setValue(this.sourceSymbol);
        }
      },
      error => {

      },
      () => {

      }
    )
  }

  getPrimarySymbol() {
    let url = (this.isDemo) ? this._urls.primaryDemoSymbolUrl : this._urls.primarySymbolUrl;
    this._api.fetchApiData(url, {}).subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resErr = data.error;
        if (resSucc != '') {
          this.targetSymbol = resSucc;
          if (this.actionType == 'edit') {
            this.createMarketForm.controls['target_symbol'].setValue(this.targetSymbolId.toString());
            console.log(this.createMarketForm);

            this.primarySymbol = this._utils.getPropValFromObj(this.targetSymbol, 'idSymbol', 'symbol', this.targetSymbolId);
          }

        }
      },
      error => {

      },
      () => {
        this.showLoader = false;
      }
    )
  }
  getCompanyList() {
    let url = (this.isDemo) ? this._urls.listDemoCompanyUrl : this._urls.compListUrl;
    this._api.fetchApiData(url, {}).subscribe(
      (data: any) => {
        let resSucc = data.data;
        if (resSucc != '') this.companyList = resSucc.companyList;
      },
      error => {

      },
      () => {

      }
    )
  }


  getMarketDetails() {
    this.showLoader = true;
    let data = { idCompanyStock: this.marketId }
    let url = (this.isDemo) ? this._urls.marketDemoDetailUrl : this._urls.marketDetailUrl;
    this._api.fetchApiData(url, data).subscribe(
      (data: any) => {
        let resSucc = data.data;
        if (resSucc != '') {
          this.targetSymbolId = resSucc.pairTarget;
          this.sourceSymbolId = resSucc.pairSource;
          this.createMarketForm.controls['target_symbol'].setValue(this.targetSymbolId);
          this.createMarketForm.controls['source_symbol'].setValue(this.sourceSymbolId);
          this.companyList.forEach(ele => {
            if (resSucc.idCompany == ele.idCompany) this.selectedIbin = ele.ibin;
          });

          this.getSymbolList();
          this.getPrimarySymbol();
          this.setMarketValues(resSucc);

        }
      },
      error => {

      },
      () => {
        this.showLoader = false;
      }
    )
  }

  public targetSymbols(data): void {
    this.targetPair = data.symbol;
  }



  setMarketValues(data) {
    let srcSym: any = { value: data.pairSource.toString() }
    let tarSym: any = { value: data.pairTarget.toString() }
    this.createMarketForm.patchValue({
      'companies': data.idCompany.toString(),
      'initial_value': data.initialValue
    });
    this.idPairSource = data.pairSource;
  }


  symbolNameChange(eve?) {
    let val = eve.value;
    this.sourceSymbol = (val != undefined) ? this._utils.getPropValFromObj(this.symbolList, 'idSymbol', 'symbol', val) : '';
  }



  targetNameChange(eve?) {
    let val = eve.value;
    //if(val != undefined) this.targetSymbol = this._utils.getPropValFromObj(this.symbolList,'id','symbol',val);
    this.primarySymbol = (val != undefined) ? this._utils.getPropValFromObj(this.targetSymbol, 'idSymbol', 'symbol', val) : '';
  }

  cancelMarketCreate() {
    this.router.navigate(['/markets/list']);
  }
  getRouteNew() {
    (this.isDemo) ? this.router.navigate(['/demo-company/markets/list']) : this.router.navigate(['/markets/list'])
  }
  ngOnInit() {
    this.createMarketFormInit();
    this.getPrimarySymbol();
    this.getCompanyList();
  }

  selectedIBIN(data) {
    this.selectedIbin = data.ibin;
  }

  ngOnChanges() {
    this.addTitle = (this.isDemo) ? 'ADD/EDIT DEMO MARKET' : 'ADD/EDIT MARKET';
    if (this.actionType == 'edit') {
      this._ar.params.subscribe(
        param => {
          this.marketId = param.id;
          this.getMarketDetails();
        }
      )
    }
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/markets/list-market/add-market/add-market.component.ts